// src/utils/encryptUtils.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'sigiriya-vr-pos-secret'; // use a better one in production

export function encryptFilters(filters) {
  const stringified = JSON.stringify(filters);
  return CryptoJS.AES.encrypt(stringified, SECRET_KEY).toString();
}

export function decryptFilters(encrypted) {
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (e) {
    return null;
  }
}
